// ═════════════════════════════════════════════════════════════════════════════
//  LOS TEXTOS DE SPACY COACH · español e inglés
//
//  Rob: «si nuestra selección es inglés, también los textos deberíamos de
//  verlos en inglés».
//
//  Tenia razon y era incoherente: el alumno ponia EN, el coach le hablaba en
//  ingles, y la pantalla alrededor seguia diciendo "Escribe tu mensaje" y
//  "Volver al gimnasio". A un alumno de C1 —que es justo el que pone EN— eso
//  le recuerda a cada segundo que esta en una app en español.
//
//  ── CUANDO SE PONE EN INGLES ────────────────────────────────────────────────
//  Cuando el idioma EFECTIVO es "en". Es decir:
//
//      EN            -> ingles              lo eligio el alumno
//      AUTO en C1/C2 -> ingles              su nivel dice que entrena en ingles
//      AUTO en A1..B2, ES, MIX -> espanol
//
//  MIX se queda en espanol a proposito. En ese modo el coach habla ingles pero
//  se pasa al espanol para rescatar al alumno cuando se atasca; si la pantalla
//  tambien estuviera en ingles, el rescate no tendria donde apoyarse.
//
//  ── POR QUE UN FICHERO Y NO UNA LIBRERIA DE IDIOMAS ─────────────────────────
//  Esto es UNA pantalla. Meter i18n entera —con sus ficheros de recursos, su
//  carga diferida y su contexto— para dos columnas de texto es traer un camion
//  para llevar una caja. El dia que NSL se traduzca de verdad, esto se sustituye
//  sin tocar la pantalla: `textos()` seguira devolviendo lo mismo.
//
//  ⚠️  Lo que se manda al COACH tambien cambia de idioma (`mensaje` en las
//      acciones). Si el boton dice "Training" y manda "¿Qué me toca hoy?", el
//      coach recibe espanol y contesta en espanol: el modo ingles se rompe
//      desde el primer clic.
// ═════════════════════════════════════════════════════════════════════════════

const es = {
  // ── La ficha, bajo el nombre ──────────────────────────────────────────────
  diasSeguidos: "días seguidos",
  tuNivel: "tu nivel",
  minutos: "minutos",
  xp: "XP",

  // ── Antes de empezar ──────────────────────────────────────────────────────
  esperandoNuevo: "Tu entrenador te está esperando. Dale y empezamos.",
  esperandoVuelve: "Tu entrenador ya revisó tu semana. Dale cuando quieras.",
  comenzar: "⚡ Comenzar entrenamiento",

  // ── Los ajustes ───────────────────────────────────────────────────────────
  ajustes: "Ajustes del coach",
  idiomaYVoz: "Idioma y voz",
  idioma: "Idioma",
  vozEncendida: "Spacy te habla",
  vozApagada: "Spacy en silencio",
  ayudaIdioma: {
    auto: "Según tu nivel",
    es: "Español con inglés dentro",
    mix: "Inglés, español para rescatar",
    en: "Todo en inglés",
  },

  // ── COMO LE HABLA ─────────────────────────────────────────────────────────
  // No es lo mismo que el idioma. El idioma es EN QUE lengua; esto es CON QUE
  // trato. Existe porque el coach nacio hablando de vestuario y eso no le vale
  // a todo el mundo: una alumna, un nino o alguien que lo usa en su trabajo.
  tono: "Trato",
  tonoGimnasio: "De gimnasio",
  tonoNeutro: "Neutro",
  ayudaTono: {
    gimnasio: "Con guasa, como un entrenador",
    neutro: "Directo y sin apodos",
  },

  // ── Lo que puede pedirle ──────────────────────────────────────────────────
  entrenar: "Entrenar",
  tocaParaOcultar: "Toca para ocultar",
  queQuieresHacer: "¿Qué quieres hacer?",
  spacyPensando: "Spacy está pensando...",
  // ── LA RUTINA DE HOY ──────────────────────────────────────────────────────
  // Los nombres de las fases son de gimnasio y no de escuela. "Calentamiento"
  // y "la serie fuerte" dicen para que sirve cada cosa; "Paso 1" y "Paso 2"
  // solo dicen en que orden van.
  rutinaEtiqueta: "Tu entrenamiento",
  rutinaTitulo: "La rutina de hoy",
  rutinaCerrar: "Cerrar la rutina",
  rutinaEmpezar: "Empezar",
  rutinaOtraVez: "Repetir",
  rutinaFinal: "🏆 Hoy no te queda nada. Nos vemos mañana.",
  rutinaMin: n => `${n} min`,
  rutinaRestan: n => `Te faltan ${n} minutos`,
  rutinaHechas: (h, t) => `${h} de ${t} hechas`,
  rutinaAbrir: (h, t) => `Abrir tu rutina de hoy · ${h} de ${t} hechas`,
  // El PORQUE de cada estacion. El backend manda la clave y, si hace falta, el
  // dato que la rellena; las palabras estan aqui porque son lo unico que cambia
  // de idioma. Es la misma division que en los botones.
  // ── LO QUE PUEDE HACER CON LA RUTINA ──────────────────────────────────────
  // Cada una manda un mensaje al coach y cierra la hoja: el alumno vuelve a la
  // conversacion y LE VE trabajar. Es la misma espera de siempre —el haz que
  // recorre el borde y los mensajes de razonamiento— y esta vez tiene sentido
  // mirarla, porque al final aparece su rutina nueva.
  //
  // El mensaje va en el idioma de la pantalla: uno en modo ingles que pulsa un
  // boton y manda espanol recibe la respuesta en espanol.
  // El subtitulo del boton de la rutina cambia con lo que tenga. Van aqui y no
  // en la pantalla porque son texto, y el texto cambia de idioma.
  rutinaBotonAbrir: (h, t) => `${h} de ${t} hechas`,
  // Con rutina abierta, "Entrenar" es el atajo a la siguiente estacion. Deja
  // de ser una segunda puerta a lo mismo y pasa a ser la puerta rapida.
  rutinaSigue: titulo => `Sigue: ${titulo}`,
  rutinaBotonCerrada: "Ya la cerraste",
  // ── ANTES DE CAMBIAR O DESCARTAR ──────────────────────────────────────────
  // Las dos preguntan primero, y las dos le dicen la VERDAD de lo que pasa.
  // Ninguna dice "vas a perder tu progreso", porque no lo pierde: cambiar
  // conserva lo hecho y descartar deja la rutina en su historial. Asustar al
  // alumno con algo que no ocurre es tan malo como no avisarle.
  rutinaSeguro: "¿Seguro?",
  rutinaCambiarAviso: (h, t) =>
    h > 0
      ? `Llevas ${h} de ${t}. Lo que ya cerraste se queda hecho; cambian las que faltan.`
      : "Todavía no has empezado ninguna. El coach te monta otra distinta.",
  rutinaDescartarAviso: (h, t) =>
    h > 0
      ? `Se va de tu pantalla. Las ${h} que cerraste hoy siguen en tu historial: eso no se borra.`
      : "Se va de tu pantalla. Puedes pedirle otra al coach cuando quieras.",
  rutinaSiCambia: "Sí, cámbiala",
  rutinaSiDescarta: "Sí, quítala",
  rutinaMejorNo: "Mejor no",
  // ── CUANDO SE LE ACABAN LOS TOKENS ────────────────────────────────────────
  // El coach GASTA credito del alumno, asi que un dia se acaba. Hasta ahora
  // ese dia el alumno veia "no hay senal" y creia que la app estaba rota: el
  // guardia devuelve 429 y la pantalla solo entendia el 402.
  //
  // Se le dice lo que pasa de verdad y las dos salidas que tiene, que es como
  // se maneja en Spacy lecciones.
  sinTokensTitulo: "Se te acabaron los tokens de IA",
  sinTokensCuerpo: "Tus tokens se renuevan el 1º de cada mes. Puedes esperar a "
    + "la renovación o comprar más y seguir hoy mismo.",
  sinTokensBoton: "Ver planes y tokens",
  sinTokensChat: "Se te acabaron los tokens de IA de este mes, crack. Se renuevan "
    + "el 1º, o puedes comprar más ahí arriba y seguimos ahora mismo.",
  sinTokensInput: "Sin tokens de IA",
  demasiadoRapido: "Vas muy rápido, campeón. Dame un segundo y lo intentas otra vez.",
  rutinaTerminada: "¡Rutina terminada!",
  // El titular ya dice que la termino; este pie NO lo repite, hace la
  // pregunta que lleva a los botones de abajo.
  rutinaBravo: "¿Y ahora?",
  rutinaOtra: "Ponme otra",
  rutinaOtraMsg: "Ya terminé mi rutina de hoy. Ponme otra distinta.",
  rutinaComoVoy: "¿Cómo voy?",
  rutinaComoVoyMsg: "Ya terminé mi rutina. ¿Cómo voy? Dime qué tal lo estoy haciendo",
  rutinaPorHoyVale: "Por hoy vale",
  rutinaCambiala: "Cámbiamela",
  rutinaCambialaMsg: "Esta rutina no me convence. Móntame otra distinta.",
  rutinaDescarta: "Descártala",
  rutinaDescartada: "Quitada. Pídesela al coach cuando quieras.",
  // ── EL HISTORIAL ──────────────────────────────────────────────────────────
  // Se lee como un registro de lo que HIZO. Ni una palabra sobre lo que dejo
  // sin hacer: los dias flojos ya se ven solos en la tira, y ademas los que no
  // entreno directamente no salen.
  rutinaHistorial: "Tus últimos días",
  rutinaRacha: n => (n === 1 ? "1 día seguido" : `${n} días seguidos`),
  rutinaResumen: (completas, estaciones) =>
    `${completas} ${completas === 1 ? "rutina cerrada" : "rutinas cerradas"}`
    + ` · ${estaciones} ${estaciones === 1 ? "estación" : "estaciones"}`,
  rutinaDia: (fecha, hechas, total) => {
    const d = new Date(`${fecha}T12:00:00`);
    return `${d.toLocaleDateString("es", { weekday: "short", day: "numeric" })}`
      + ` · ${hechas} de ${total}`;
  },
  rutinaPorque: (clave, dato) => ({
    tus_palabras: "con las palabras en las que te trabas al hablar",
    de_tu_nivel: "vocabulario de tu nivel, para calentar",
    a_medias: "la dejaste a medias",
    sin_empezar: "todavía no la has empezado",
    la_pediste: "la pediste tú",
    te_toca: "es la que te toca ahora",
    fallas: dato ? `porque fallas ${dato}` : "por lo que más fallas",
    cambio_de_ritmo: "para cambiar de ritmo",
    nunca_te_he_oido: "todavía no te he oído hablar",
    para_oirte: "para oírte y decirte cómo suenas",
  }[clave] || ""),
  rutinaFases: {
    vocabulario: "Calentamiento",
    clase: "La serie fuerte",
    minijuego: "Accesorio",
    hablar: "El remate",
  },
  // Lo que sale en la conversacion cuando acaba de montarla.
  rutinaLista: "Tu rutina está lista",
  rutinaVerla: "Ábrela arriba",
  ocultarAcciones: "Ocultar las acciones",
  mostrarAcciones: "Mostrar las acciones",
  acciones: [
    // ── ENTRENAR vs MI RUTINA ────────────────────────────────────────────
    // Eran lo mismo y el alumno no sabia cual pulsar. La diferencia es el
    // TAMANO de lo que pide: una clase suelta o el dia entero. Y cuando ya
    // tiene rutina, "Entrenar" deja de competir con ella y se convierte en el
    // atajo a su siguiente estacion — la pantalla le reescribe el subtitulo.
    { id: "toca", emoji: "🏋️", etiqueta: "Entrenar", sub: "Solo una clase",
      color: "#facc15", mensaje: "¿Qué me toca hoy? Ponme una clase" },
    // No manda nada al coach: abre el recorrido en la propia pantalla. Es la
    // puerta de vuelta para quien lo omitió el primer día —Rob: «el botón sí o
    // sí lo debemos tener, para que si se traban ahí lo puedan solucionar»—, y
    // por eso NO gasta Energía: lo que cuenta siempre dice lo mismo.
    // Rob, 29-09-2026: «se descuadra por demasiado texto». Era el unico boton
    // con la etiqueta de cuatro palabras, asi que su tarjeta crecia una linea
    // mas y rompia la fila entera. Ahora dice lo mismo en dos —y sigue
    // diciendo QUE es: el recorrido de toda la app, no un truco suelto—.
    { id: "recorrido", emoji: "🧭", etiqueta: "Cómo funciona",
      sub: "En un minuto", color: "#facc15", local: true },
    // Este boton tiene DOS destinos y por eso su subtitulo se reescribe en la
    // pantalla: si ya tiene rutina abre la suya sin gastar una llamada a la IA,
    // y si no la tiene, se la pide al coach.
    { id: "rutina", emoji: "🗓️", etiqueta: "Mi rutina", sub: "El día entero",
      color: "#facc15", mensaje: "Móntame mi rutina de entrenamiento de hoy" },
    { id: "termine", emoji: "✅", etiqueta: "Terminé", sub: "Ya hice mi clase",
      color: "#22c55e", mensaje: "Ya terminé mi clase" },
    { id: "voy", emoji: "📊", etiqueta: "Mi progreso", sub: "¿Cómo voy?",
      color: "#60a5fa", mensaje: "¿Cómo voy esta semana?" },
    { id: "vocab", emoji: "🔤", etiqueta: "Vocabulario", sub: "Ponme palabras",
      color: "#a78bfa", mensaje: "Ponme un juego de vocabulario" },
    { id: "jugar", emoji: "🎮", etiqueta: "Jugar", sub: "Un minijuego",
      color: "#f472b6", mensaje: "Quiero jugar un minijuego" },
    // Este boton NO lo ve todo el mundo: el expediente lo esconde mientras no
    // haya ni una grabacion con voz. Ofrecerle "¿Cómo hablo?" a quien no ha
    // hablado nunca es abrirle una puerta a una habitacion vacia.
    { id: "hablo", emoji: "🎤", etiqueta: "Cómo hablo", sub: "¿Se me entiende?",
      color: "#a3e635", mensaje: "¿Cómo hablo? ¿Se me entiende cuando hablo en inglés?" },
    // Estos dos no son un capricho: eran los unicos asistentes construidos que
    // NO tenian boton, asi que el alumno tenia que adivinar que existian.
    // No se llama "¿Cuándo entreno?" a secas porque nadie se hace esa pregunta.
    // La que si se hace es si es constante, y la respuesta —tenga costumbre o
    // no— sale de sus dias registrados.
    { id: "cuando", emoji: "🕗", etiqueta: "Mis hábitos", sub: "¿Cuándo entreno?",
      color: "#38bdf8", mensaje: "¿Cuándo suelo entrenar? ¿Soy constante?" },
    { id: "fallos", emoji: "🔍", etiqueta: "Mis fallos", sub: "¿En qué ando flojo?",
      color: "#fb923c", mensaje: "¿En qué ando flojo? Dime qué se me rompe más" },
    // Y este lo pregunto Rob EL MISMO en una conversacion real: «oye por cierto
    // cuanto saque en mi examen y por que soy A2». Si el dueño del producto
    // tiene que escribirlo a mano, un alumno no lo pregunta nunca.
    { id: "examen", emoji: "🎯", etiqueta: "Mi examen", sub: "¿Cuánto saqué?",
      color: "#2dd4bf", mensaje: "¿Cuánto saqué en mi examen y por qué ese nivel?" },
  ],

  // ── LO QUE SE LEE MIENTRAS PIENSA ─────────────────────────────────────────
  // Van rotando en la tarjeta de espera. NO son un adorno: una espera de seis
  // segundos con tres puntos se siente rota, y la misma espera con "abriendo
  // tu expediente" se siente trabajando.
  //
  // Y describen lo que el coach HACE de verdad: abrir el expediente, mirar el
  // examen, comparar destrezas, buscar palabras. No van sincronizadas con la
  // consulta exacta de ese turno —eso pediria que el backend fuera contando en
  // vivo— pero ninguna dice algo que el coach no sepa hacer.
  pensando: [
    { icon: "📋", text: "Abriendo tu expediente…" },
    { icon: "🎯", text: "Mirando tu examen de nivel…" },
    { icon: "📊", text: "Comparando tus destrezas…" },
    { icon: "📘", text: "Revisando tus clases…" },
    { icon: "🔥", text: "Contando tus días seguidos…" },
    { icon: "🔤", text: "Buscando las palabras que se te atragantan…" },
    { icon: "🥊", text: "Preparando tu entrenamiento…" },
  ],

  // ── La caja de escribir ───────────────────────────────────────────────────
  escribe: "Escribe tu mensaje...",
  teEscucho: "Te escucho…",
  parar: "Parar",
  hablar: "Hablar",
  pararDeHablar: "Parar de hablar",
  hablarAlCoach: "Hablar al coach",
  limpiarTexto: "Limpiar texto",
  enviarMensaje: "Enviar mensaje",

  // ── El minijuego que te pone ──────────────────────────────────────────────
  juegoParaTi: "Tu juego de hoy",
  jugarAhora: "Jugar ahora →",
  entrenaEsto: entrena => `Entrena ${entrena}`,
  porqueFallas: (tema, veces) =>
    `Se te rompe en ${tema}${veces ? ` · ${veces} veces` : ""}`,
  otrosJuegos: "O si prefieres otro",

  // ── Lo que te pone el coach ───────────────────────────────────────────────
  salaEtiqueta: "Sala del gimnasio",
  salaEntrar: "Entrar →",
  entrenamientoDeHoy: "Tu entrenamiento de hoy",
  entrarAEntrenar: "Entrar a entrenar →",
  vocabularioDeTuNivel: "Vocabulario de tu nivel",
  palabrasAtragantan: n => `${n} palabras que se te atragantan`,
  machacarVocabulario: "Machacar vocabulario →",

  // ── Cuando algo va mal ────────────────────────────────────────────────────
  planInactivo: "Tu plan no esta activo, fiera. Actívalo y seguimos entrenando.",
  sinSenal: "Se me fue la señal un momento. Repítemelo.",
  microDenegado: "No me dejas oírte. Activa el micrófono en tu navegador.",
  microNoEntendio: "No pude oírte bien. Prueba otra vez o escríbeme.",

  volver: "← Volver al gimnasio",
};

const en = {
  diasSeguidos: "day streak",
  tuNivel: "your level",
  minutos: "minutes",
  xp: "XP",

  esperandoNuevo: "Your coach is waiting for you. Hit it and let's go.",
  esperandoVuelve: "Your coach already went over your week. Start whenever.",
  comenzar: "⚡ Start training",

  ajustes: "Coach settings",
  idiomaYVoz: "Language and voice",
  idioma: "Language",
  vozEncendida: "Spacy speaks to you",
  vozApagada: "Spacy on mute",
  ayudaIdioma: {
    auto: "Based on your level",
    es: "Spanish with English inside",
    mix: "English, Spanish to rescue you",
    en: "All in English",
  },

  tono: "Style",
  tonoGimnasio: "Gym",
  tonoNeutro: "Neutral",
  ayudaTono: {
    gimnasio: "Playful, like a coach",
    neutro: "Direct, no nicknames",
  },

  entrenar: "Train",
  tocaParaOcultar: "Tap to hide",
  queQuieresHacer: "What do you want to do?",
  spacyPensando: "Spacy is thinking...",
  // ── LA RUTINA DE HOY ──────────────────────────────────────────────────────
  rutinaEtiqueta: "Your session",
  rutinaTitulo: "Today's routine",
  rutinaCerrar: "Close the routine",
  rutinaEmpezar: "Start",
  rutinaOtraVez: "Again",
  rutinaFinal: "🏆 Nothing left today. See you tomorrow.",
  rutinaMin: n => `${n} min`,
  rutinaRestan: n => `${n} minutes to go`,
  rutinaHechas: (h, t) => `${h} of ${t} done`,
  rutinaAbrir: (h, t) => `Open today's routine · ${h} of ${t} done`,
  rutinaBotonAbrir: (h, t) => `${h} of ${t} done`,
  rutinaSigue: titulo => `Next: ${titulo}`,
  rutinaBotonCerrada: "You closed it",
  rutinaSeguro: "Sure?",
  rutinaCambiarAviso: (h, t) =>
    h > 0
      ? `You are ${h} of ${t} in. What you closed stays closed; only the rest changes.`
      : "You have not started any of them. The coach will build you a different one.",
  rutinaDescartarAviso: (h, t) =>
    h > 0
      ? `It leaves your screen. The ${h} you closed today stay in your history: that is not deleted.`
      : "It leaves your screen. You can ask the coach for another one whenever you want.",
  rutinaSiCambia: "Yes, change it",
  rutinaSiDescarta: "Yes, drop it",
  rutinaMejorNo: "Never mind",
  sinTokensTitulo: "You are out of AI tokens",
  sinTokensCuerpo: "Your tokens renew on the 1st of each month. You can wait for "
    + "the renewal or buy more and keep going today.",
  sinTokensBoton: "See plans and tokens",
  sinTokensChat: "You are out of AI tokens for this month. They renew on the 1st, "
    + "or you can buy more up there and we keep going right now.",
  sinTokensInput: "No AI tokens",
  demasiadoRapido: "Too fast. Give me a second and try again.",
  rutinaTerminada: "Routine done!",
  rutinaBravo: "What now?",
  rutinaOtra: "Give me another",
  rutinaOtraMsg: "I finished today's routine. Give me a different one.",
  rutinaComoVoy: "How am I doing?",
  rutinaComoVoyMsg: "I finished my routine. How am I doing? Tell me how it's going",
  rutinaPorHoyVale: "That's it for today",
  rutinaCambiala: "Change it",
  rutinaCambialaMsg: "I'm not sold on this routine. Build me a different one.",
  rutinaDescarta: "Drop it",
  rutinaDescartada: "Dropped. Ask the coach for one whenever you want.",
  // ── EL HISTORIAL ──────────────────────────────────────────────────────────
  rutinaHistorial: "Your last days",
  rutinaRacha: n => (n === 1 ? "1 day in a row" : `${n} days in a row`),
  rutinaResumen: (completas, estaciones) =>
    `${completas} ${completas === 1 ? "routine closed" : "routines closed"}`
    + ` · ${estaciones} ${estaciones === 1 ? "station" : "stations"}`,
  rutinaDia: (fecha, hechas, total) => {
    const d = new Date(`${fecha}T12:00:00`);
    return `${d.toLocaleDateString("en", { weekday: "short", day: "numeric" })}`
      + ` · ${hechas} of ${total}`;
  },
  rutinaPorque: (clave, dato) => ({
    tus_palabras: "with the words you stumble on when you speak",
    de_tu_nivel: "vocabulary at your level, to warm up",
    a_medias: "you left it half done",
    sin_empezar: "you haven't started it yet",
    la_pediste: "you asked for it",
    te_toca: "it's the one you're on now",
    fallas: dato ? `because you keep missing ${dato}` : "for what you miss most",
    cambio_de_ritmo: "to change the pace",
    nunca_te_he_oido: "I haven't heard you speak yet",
    para_oirte: "so I can hear you and tell you how you sound",
  }[clave] || ""),
  rutinaFases: {
    vocabulario: "Warm-up",
    clase: "Main set",
    minijuego: "Accessory",
    hablar: "Finisher",
  },
  rutinaLista: "Your routine is ready",
  rutinaVerla: "Open it above",
  ocultarAcciones: "Hide the actions",
  mostrarAcciones: "Show the actions",
  // El `id` y el `color` son los mismos que en espanol: lo que cambia es lo que
  // se lee y lo que se le manda al coach, no que boton es cual.
  acciones: [
    { id: "toca", emoji: "🏋️", etiqueta: "Train", sub: "Just one class",
      color: "#facc15", mensaje: "What should I train today? Give me one class" },
    { id: "recorrido", emoji: "🧭", etiqueta: "How it works",
      sub: "One minute", color: "#facc15", local: true },
    { id: "rutina", emoji: "🗓️", etiqueta: "My routine", sub: "The whole day",
      color: "#facc15", mensaje: "Build me my training routine for today" },
    { id: "termine", emoji: "✅", etiqueta: "Done", sub: "I finished my lesson",
      color: "#22c55e", mensaje: "I finished my lesson" },
    { id: "voy", emoji: "📊", etiqueta: "My progress", sub: "How am I doing?",
      color: "#60a5fa", mensaje: "How am I doing this week?" },
    { id: "vocab", emoji: "🔤", etiqueta: "Vocabulary", sub: "Give me words",
      color: "#a78bfa", mensaje: "Give me a vocabulary game" },
    { id: "jugar", emoji: "🎮", etiqueta: "Play", sub: "A minigame",
      color: "#f472b6", mensaje: "I want to play a minigame" },
    { id: "hablo", emoji: "🎤", etiqueta: "My speaking", sub: "Am I clear?",
      color: "#a3e635", mensaje: "How is my speaking? Am I clear when I speak English?" },
    { id: "cuando", emoji: "🕗", etiqueta: "My habits", sub: "When do I train?",
      color: "#38bdf8", mensaje: "When do I usually train? Am I consistent?" },
    { id: "fallos", emoji: "🔍", etiqueta: "My weak spots", sub: "What do I get wrong?",
      color: "#fb923c", mensaje: "What am I weak at? Tell me what I keep getting wrong" },
    { id: "examen", emoji: "🎯", etiqueta: "My test", sub: "What did I score?",
      color: "#2dd4bf", mensaje: "What did I score on my level test and why that level?" },
  ],

  pensando: [
    { icon: "📋", text: "Opening your file…" },
    { icon: "🎯", text: "Checking your level test…" },
    { icon: "📊", text: "Comparing your skills…" },
    { icon: "📘", text: "Going through your lessons…" },
    { icon: "🔥", text: "Counting your streak…" },
    { icon: "🔤", text: "Finding the words that trip you up…" },
    { icon: "🥊", text: "Getting your training ready…" },
  ],

  escribe: "Type your message...",
  teEscucho: "I'm listening…",
  parar: "Stop",
  hablar: "Speak",
  pararDeHablar: "Stop speaking",
  hablarAlCoach: "Speak to your coach",
  limpiarTexto: "Clear text",
  enviarMensaje: "Send message",

  juegoParaTi: "Your game today",
  jugarAhora: "Play now →",
  entrenaEsto: entrena => `Trains ${entrena}`,
  porqueFallas: (tema, veces) =>
    `You keep tripping on ${tema}${veces ? ` · ${veces} times` : ""}`,
  otrosJuegos: "Or pick another one",

  salaEtiqueta: "Training room",
  salaEntrar: "Go in →",
  entrenamientoDeHoy: "Your training for today",
  entrarAEntrenar: "Go train →",
  vocabularioDeTuNivel: "Vocabulary for your level",
  palabrasAtragantan: n => `${n} words that trip you up`,
  machacarVocabulario: "Drill this vocabulary →",

  planInactivo: "Your plan isn't active, champ. Turn it on and we keep training.",
  sinSenal: "Lost you for a second there. Say it again.",
  microDenegado: "You're not letting me hear you. Turn the mic on in your browser.",
  microNoEntendio: "I couldn't hear you well. Try again or write to me.",

  volver: "← Back to the gym",
};

export const TEXTOS = { es, en };

/**
 * Los textos que tocan, segun el idioma EFECTIVO de la conversacion.
 *
 * Solo "en" cambia la pantalla. `auto` ya llega resuelto desde la pantalla: si
 * el alumno es C1 y no ha tocado nada, aqui llega "en" y la interfaz se pone en
 * ingles con el coach, que es lo coherente.
 */
export function textos(idiomaEfectivo) {
  return idiomaEfectivo === "en" ? en : es;
}
